<style lang="less" scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #ffffff;
  }
</style>

<template lang="pug">
  .header
    .stop(@click='handleStop') 그만하기
    .recall(@click='handleRecall') 리콜시작
</template>

<script>
export default {
  methods: {
    handleStop() {
      this.$emit('click-stop');
    },
    handleRecall() {
      this.$emit('click-recall');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/header_recall.vue